import { StepOrder } from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList";

export const getLastUnpaidOrderIndex = (stepperState: StepOrder[]) =>
  stepperState.reduce(
    (acc, o, idx) => (!o.isPaid && idx > acc ? idx : acc),
    -1
  );

export const getLastFailedOrderIndex = (stepperState: StepOrder[]) =>
  stepperState.reduce((acc, o, idx) => (o.error && idx > acc ? idx : acc), -1);
